import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined';
import ContactsOutlinedIcon from '@mui/icons-material/ContactsOutlined';
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import InventoryIcon from '@mui/icons-material/Inventory';
import BallotIcon from '@mui/icons-material/Ballot';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import GavelIcon from '@mui/icons-material/Gavel';
import Groups3Icon from '@mui/icons-material/Groups3';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import EmailIcon from '@mui/icons-material/Email';

// Prioritäts-Konstanten für Suchergebnis-Sortierung
export const PRIORITY = {
  HIGH: 1, // Leads, Projekte, Rechnungen
  MEDIUM: 2, // Angebote, Aufträge, Verträge
  LOW: 3, // Stammdaten und andere
};

export const searchResultMap = {
  companies: {
    label: 'Companies',
    Icon: ApartmentOutlinedIcon,
    to: '/companies/',
    path: 'companies',
    priority: PRIORITY.LOW,
  },
  contacts: {
    label: 'Contacts',
    Icon: ContactsOutlinedIcon,
    to: '/contacts/',
    path: 'contacts',
    priority: PRIORITY.LOW,
  },
  contracts: {
    label: 'Contracts',
    Icon: GavelIcon,
    to: '/contracts/',
    path: 'contracts',
    priority: PRIORITY.MEDIUM,
  },
  //files: { label: "Files", Icon: FolderOutlinedIcon },
  invoices: {
    label: 'Invoices',
    Icon: ReceiptOutlinedIcon,
    to: '/invoices/',
    path: 'invoices',
    priority: PRIORITY.HIGH,
  },
  offers: {
    label: 'Offers',
    Icon: DescriptionOutlinedIcon,
    to: '/offers/',
    path: 'offers',
    priority: PRIORITY.MEDIUM,
  },
  orders: {
    label: 'Orders',
    Icon: BallotIcon,
    to: '/orders/',
    path: 'orders',
    priority: PRIORITY.MEDIUM,
  },
  products: {
    label: 'Products',
    Icon: InventoryIcon,
    to: '/products/',
    path: 'products',
    priority: PRIORITY.LOW,
  },
  projects: {
    label: 'Projects',
    Icon: AccountTreeOutlinedIcon,
    to: '/projects/management/',
    path: 'projects',
    priority: PRIORITY.HIGH,
  },
  services: {
    label: 'Services',
    Icon: SupervisedUserCircleIcon,
    to: '/services/',
    path: 'services',
    priority: PRIORITY.LOW,
  },
  users: {
    label: 'Employees',
    Icon: PeopleOutlinedIcon,
    to: '/employees/',
    path: 'users/reduced',
    priority: PRIORITY.LOW,
  },
  receipts: {
    label: 'Expenses',
    Icon: RequestQuoteIcon,
    to: '/expenses/receipts/',
    path: 'receipts',
    priority: PRIORITY.LOW,
  },
  dunning_processes: {
    label: 'Payment Reminder',
    Icon: NotificationsActiveIcon,
    to: '/payment-reminders/',
    path: 'dunning-processes',
    priority: PRIORITY.LOW,
  },
  company_leads: {
    label: 'Company Leads',
    Icon: Groups3Icon,
    to: '/leads/companies/',
    path: 'leads/companies',
    priority: PRIORITY.HIGH,
  },
  person_leads: {
    label: 'Person Leads',
    Icon: Groups3Icon,
    to: '/leads/persons/',
    path: 'leads/persons',
    priority: PRIORITY.HIGH,
  },
  /*imap_emails: {
    label: 'Emails',
    Icon: EmailIcon,
    to: '/emails/',
    path: 'emails',
  },*/
};
